import { mapGetters } from 'vuex';

export const scroll = {
  computed: {
    ...mapGetters({
      isHeaderScrolled: 'general/isScrolled'
    })
  },
  methods: {
    scrollToError(offset = this.isHeaderScrolled ? -60 : -90, container = 'body') {
      const containerEl = container === 'body' ? document : document.querySelector(container);
      const errorEl =
        containerEl?.querySelector('.v-input.error--text:not(.v-messages)') ||
        containerEl?.querySelector('.error--text:not(.d-none)');

      if (errorEl) {
        this.$scrollTo(errorEl, 300, {
          offset,
          container,
          force: true,
          onDone: () => {
            const focusTarget =
              errorEl.querySelector('textarea') || errorEl.querySelector('input') || errorEl;
            focusTarget?.focus();
          }
        });
      }
    },
    dialogScrollTop() {
      // Web (Vuetify v-dialog)
      const webDialog = document.querySelector('.v-dialog--active .dialog-main-content');
      if (webDialog) {
        webDialog.scrollTop = 0;
        return;
      }
      // Capacitor: the outer fixed holder and its inner scrollable area both need resetting
      const mobileHolder = document.querySelector('.mobile-app-dialog-holder');
      if (mobileHolder) mobileHolder.scrollTop = 0;
      const mobileDialog = document.querySelector('.dialog-main-content');
      if (mobileDialog) mobileDialog.scrollTop = 0;
    }
  }
};
